import { useEffect, useState } from 'react';

import get from 'lodash/get';

import { getSharedVolumePersistentVolumeClaims } from '../api';
import type { PvcOptionItem } from '../types';

function getPvcDescription(item: unknown): string {
  const annotations = get(item, 'metadata.annotations') as Record<string, string> | undefined;
  return String(get(annotations, 'stack.io/description') || get(annotations, 'stack.io/describe') || '').trim();
}

export function usePvcOptions(namespace?: string, enabled = true) {
  const [options, setOptions] = useState<PvcOptionItem[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setOptions([]);
      setIsLoading(false);
      return;
    }

    let cancelled = false;

    const load = async () => {
      setIsLoading(true);
      try {
        const res = await getSharedVolumePersistentVolumeClaims(namespace ? { namespace } : undefined);
        if (cancelled) return;
        const items = res?.items ?? [];
        setOptions(
          items.map((raw) => {
            const annotations = get(raw, 'metadata.annotations') as Record<string, string> | undefined;
            return {
              value: String(get(raw, 'metadata.name') || ''),
              label: String(annotations?.['stack.io/aliase'] || get(raw, 'metadata.name') || ''),
              storage: String(get(raw, 'status.capacity.storage') || ''),
              description: getPvcDescription(raw),
            };
          }),
        );
      } catch (error) {
        console.log(error);
        if (!cancelled) setOptions([]);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    void load();

    return () => {
      cancelled = true;
    };
  }, [enabled, namespace]);

  return { options, isLoading };
}
